<button mat-button *ngFor="let tab of tabs" class="btn btn--fl btn--subtab"
  [class.active]="tab.id === selectedTransType"
  disabled="{{ tab.value > 0 ? false : true }}" (click)="navigateRoutes(tab.id)">
  <span *ngIf="['KOR','TWN','SGP','IDN','HKG','CHN','THA','PHL','VNM'].includes(getUserCountry()); else allTabs">
    <span *ngIf="tab.id !== 'dsf'">
      <span >{{ tab.name.toLowerCase() }}</span>
      <span>({{tab.value}})</span>
    </span>
  </span>
  <ng-template #allTabs >
    <span >{{ tab.name.toLowerCase() }}</span>
    <span>({{ tab.value }})</span>
  </ng-template>
</button>
